import { ChangeEvent } from 'react';
import { Autocomplete as MuiAutocomplete, AutocompleteProps } from '@mui/material';
import { styled } from '@mui/material';

import TextInput from '~/components/ui/TextInput';

interface CustomAutocompleteProps<T> extends Omit<AutocompleteProps<T, boolean, boolean, boolean>, 'renderInput'> {
  placeholder?: string;
  label?: string;
  onTextInputChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function Autocomplete<T>({
  placeholder,
  label,
  onTextInputChange,
  ...rest
}: CustomAutocompleteProps<T>) {
  return (
    <StyledAutocomplete
      {...rest}
      renderInput={(params) => (
        <TextInput {...params} placeholder={placeholder} label={label} onChange={onTextInputChange} />
      )}
    />
  );
}

export const StyledAutocomplete = styled(MuiAutocomplete)(() => ({
  '.MuiAutocomplete-input': {
    padding: '0 7px !important',
  },
}));
